module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedit"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("To")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("Oberst Birger Kristian Eriksen")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("and the others who fought and died")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("in the battle for Norway in 1940.")]), _vm._v(" "), _c('div', {
    staticClass: "img_containert",
    attrs: {
      "id": "pgiiimg1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00ii-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e769733a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 60
// module chunks = 0